import { jsx as r } from "../../../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import p from "../../../../../core/Context/useCoreContext.js";
import { Tooltip as e } from "../../../../internal/Tooltip/Tooltip.js";
import { TypographyVariant as m } from "../../../../internal/Typography/types.js";
import a from "../../../../internal/Typography/Typography.js";
import { Fragment as s } from "../../../../../external/preact/dist/preact.module.js";
function l({ value: t, isContainerHovered: n }) {
  const { i18n: o } = p(), i = `tooltip.${t}`;
  return /* @__PURE__ */ r(s, { children: o.has(i) && /* @__PURE__ */ r(e, { content: o.get(i), isContainerHovered: n, children: /* @__PURE__ */ r("span", { children: /* @__PURE__ */ r(a, { variant: m.BODY, children: o.has(`txType.${t}`) ? o.get(`txType.${t}`) : `${t}` }) }) }) });
}
export {
  l as default
};
